import React from "react";

const NoticeIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4269_71989)">
          <path
            d="M3.37383 19.5974C1.7807 17.667 0.823975 15.1919 0.823975 12.4939C0.823975 9.70414 1.84702 7.15358 3.53823 5.19638"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M20.3508 5.08914C22.0978 7.05974 23.1582 9.65264 23.1582 12.4939C23.1582 15.1708 22.2163 17.6275 20.6457 19.5515"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M11.9907 21.5193C16.9753 21.5193 21.0161 17.4785 21.0161 12.4939C21.0161 7.50928 16.9753 3.46848 11.9907 3.46848C7.00614 3.46848 2.96533 7.50928 2.96533 12.4939C2.96533 17.4785 7.00614 21.5193 11.9907 21.5193Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M11.9815 14.2514C11.2985 14.2514 10.7454 13.6982 10.7454 13.0153V7.42732C10.7454 6.74434 11.2985 6.19119 11.9815 6.19119C12.6645 6.19119 13.2176 6.74434 13.2176 7.42732V13.0153C13.2176 13.6975 12.6645 14.2514 11.9815 14.2514Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
          <path
            d="M11.9998 18.7966C12.6825 18.7966 13.2359 18.2431 13.2359 17.5604C13.2359 16.8777 12.6825 16.3243 11.9998 16.3243C11.3171 16.3243 10.7637 16.8777 10.7637 17.5604C10.7637 18.2431 11.3171 18.7966 11.9998 18.7966Z"
            stroke={props?.color ?? "black"}
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_4269_71989">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default NoticeIcon;
